export default (to) => {
    if (/organizers\/:organizerId/.test(to)) {
        to = to.replace(/:organizerId/, localStorage.getItem('organizerId'))
    }
    return to
}